class GiftcardForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    if (this?.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, 'click', this.handleTrigger)
      })
    }

    if (this?.els?.form?.exists && this?.els?.submit?.exists) {
      this.els.form.elements.forEach(formEl => {
        this.listeners.add(formEl, 'submit', this.handleSubmit)
      })
    }
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    const currentState = triggerEl.getAttribute('aria-expanded') === 'true'
    triggerEl.setAttribute('aria-expanded', !currentState)
    this.setAttribute('aria-expanded', !currentState)
  }

  async handleSubmit (event) {
    event.preventDefault()
    const formData = new FormData(event.target)
    const discountCodes = `${formData.get('discount')},${
      this.els.input.element.dataset.current
    }`

    const state = await window.BAO.Cart.updateCartDiscount(discountCodes)

    if (!state) return

    const code = state.discount_codes?.[0]
    const applied = Boolean(code?.applicable)

    this.announceResult(applied, state)

    if (applied) {
      this.removeAttribute('aria-expanded')
      document.querySelector(this.els?.trigger?.selector)?.click()
      this.focusAfterRender(this.els?.trigger?.selector)
    } else {
      this.focusAfterRender(this.els?.input?.selector)
    }
  }

  /**
   * @param {boolean} applied
   * @param {Object} state The cart returned after the discount update
   *
   * @returns {void}
   */
  announceResult (applied, state) {
    if (!applied) {
      window.BAO.Utils.announce(this.dataset.announceInvalid)

      return
    }

    const percentage = state.cart_level_discount_applications?.find(
      discount => discount.value_type === 'percentage',
    )?.value

    const template = percentage
      ? this.dataset.announceAppliedPercent
      : this.dataset.announceApplied

    window.BAO.Utils.announce(template?.replace('{{ percent }}', percentage))
  }

  /**
   * The form re-renders with the cart, so the element that had focus is gone.
   * Focus its replacement instead, so focus doesn't drop to the top of the page.
   *
   * @param {string|undefined} selector
   *
   * @returns {void}
   */
  focusAfterRender (selector) {
    if (!selector) return

    document.querySelector(selector)?.focus()
  }

  handleResponse (code) {
    this.ariaInvalid = !code.applicable
    if (code.applicable === true) {
      if (this.els.error.element) {
        this.els.error.element.value = this.els.submit.element.dataset.applied
        this.els.error.element.disabled = true
      }
    }
  }
}

if (!customElements.get('giftcard-form')) {
  customElements.define('giftcard-form', GiftcardForm)
}
